import {
  ContentDetailMetricsContentType,
  ContentDetailMetricsItemType,
} from '.';

export const getValue = <
  C extends ContentDetailMetricsContentType,
  M extends ContentDetailMetricsItemType<C>,
  K extends keyof M,
>(
  content: C,
  metric: M[K],
  metricKey: any,
) => {
  let value: any;

  if (metric?.value) {
    value = metric.value(content);
  } else {
    value = content[metricKey as keyof C];
  }

  // Special handling for Instagram Reels viewsCount to match content card logic
  if (
    metricKey === 'viewsCount' &&
    content.platform === 'instagram' &&
    content.productType === 'REELS'
  ) {
    const viewsCount = content[metricKey as keyof C];
    const igReelsAggregatedAllPlaysCount = (content as any)
      .igReelsAggregatedAllPlaysCount;

    value = viewsCount || igReelsAggregatedAllPlaysCount;
  }

  if (value && metric?.transformValue) {
    value = metric.transformValue(value);
  }

  return value;
};
